import CloseButton from '@/components/CloseButton/CloseButton';
import {StickyPageLayout} from '@/components/Layout';
import routerService from '@/services/route/routerService';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import AutoDeliveryDcxDetailsFooter from '../components/AutoDeliveryDcxDetailsFooter';
import AutoDeliveryDcxHelpSupport from '../components/AutoDeliveryDcxHelpSupport';
import AutoDeliveryDcxMobileNumber from '../components/AutoDeliveryDcxMobileNumber';
import AutoDeliveryDcxOrder from '../components/AutoDeliveryDcxOrder';
import AutoDeliveryDcxOrderAddress from '../components/AutoDeliveryDcxOrderAddress';
import AutoDeliveryDcxPaymentMethod from '../components/AutoDeliveryDcxPaymentMethod';
import useSkipDelivery from '../hooks/useSkipDelivery';
import ConfirmSkipButton from './ConfirmSkipButton';
import DeliverySkipSection from './DeliverySkipSection';

const SkipDeliveryMobile = ({title}: {title: string}) => {
    const {
        order: {deliveryAddress, products, price, paymentInfo},
        autoDelivery: {isSkipDeliveryAvailable, isFreezed},
    } = useSkipDelivery();

    const handleClose = () => {
        routerService.goBack();
    };

    return (
        // @ts-expect-error
        <StickyPageLayout
            contentClassName='flex-1 text-start min-h-min'
            headerOptions={{
                // @ts-expect-error CloseButton is not typed
                endIcon: <CloseButton onClick={handleClose} />,
                title,
            }}
            footer={
                isSkipDeliveryAvailable && (
                    <AutoDeliveryDcxDetailsFooter>
                        <ConfirmSkipButton />
                    </AutoDeliveryDcxDetailsFooter>
                )
            }
            footerClassName='border-t-[1px] border-french-gray bg-primary-dark-5 border-t-primary-dark-15'
        >
            <WarningBannersTop source={WARNING_BANNER_SOURCE_TYPES.AUTO_DELIVERY} />
            <div className='mt-safe-offset-sticky-header p-4 pt-0'>
                <DeliverySkipSection />
            </div>
            <AutoDeliveryDcxOrder
                className='border-t-8 border-primary-dark-5 md:px-8'
                products={products}
                price={price}
                isEditAllowed
                isCompact
            />
            <AutoDeliveryDcxPaymentMethod
                className='border-t-8 border-primary-dark-5 md:px-8'
                isUpdateDisabled={isFreezed}
                paymentInfo={paymentInfo}
            />
            <AutoDeliveryDcxOrderAddress
                className='border-t-8 border-primary-dark-5 md:px-8'
                address={deliveryAddress}
                isEditAllowed
            />
            <AutoDeliveryDcxMobileNumber className='border-t-8 border-primary-dark-5 md:px-8' />
            <AutoDeliveryDcxHelpSupport className='border-t-8 border-primary-dark-5 md:px-8' />
            {/* @ts-expect-error */}
            <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.AUTO_DELIVERY} />
        </StickyPageLayout>
    );
};

export default SkipDeliveryMobile;
